var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket_help_chat_popup"},[_c('div',{staticClass:"bot_ticket_popup"},[_c('div',{staticClass:"bot_ticket_popup_center"},[_c('div',{staticClass:"bot_ticket_popup_modal"},[_c('div',{staticClass:"bot_ticket_popup_body"},[_c('admin-chat',{attrs:{"ticketInfo":_vm.ticketInfo}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }